export const STATUS_COLORS: Record<string, string> = {
  pending: 'bg-yellow-100 text-yellow-800',
  reviewed: 'bg-blue-100 text-blue-800',
  action_taken: 'bg-red-100 text-red-800',
  dismissed: 'bg-gray-100 text-gray-800',
};

export const STATUS_LABELS: Record<string, string> = {
  pending: 'Pending',
  reviewed: 'Reviewed',
  action_taken: 'Action taken',
  dismissed: 'Dismissed',
};

export const TYPE_LABELS: Record<string, string> = {
  spam: 'Spam',
  harassment: 'Harassment',
  inappropriate: 'Inappropriate content',
  impersonation: 'Impersonation',
  other: 'Other',
};

export const CONTEXT_LABELS: Record<string, string> = {
  dm: 'Direct message',
  invitation: 'Invitation',
  profile: 'Profile',
  photo: 'Photo',
  friend_request: 'Kizu request',
  other: 'Other',
};

export const RESOLUTION_LABELS: Record<string, string> = {
  dismissed: 'Dismissed',
  warned: 'Warned',
  banned: 'Banned from circle',
};

export function getInitials(name?: string): string {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
}
